export interface EventData {
    eventName: Gtag.EventNames | string;
    eventParams?: Gtag.ControlParams | Gtag.EventParams | Gtag.CustomParams;
}

export function trackEvent(eventName: EventData['eventName'], eventParams?: EventData['eventParams']) {
    if (!window.gtag) {
        console.info('trackEvent', eventName, eventParams);
        return;
    }
    gtag('event', eventName, eventParams);
}
